import React from "react";
import MobilSearch from "../../../../assets/images/mobil-search.png";
import MobilSearchNew from "../../../../assets/images/filter-icon.svg";
import Image from "../../../../component/image/Image";
import SingleSelect from "../../../../component/singleSelect/SingleSelect";
import ShareIcon from "../../../../assets/images/share_icon.png";
import DataIcon from "../../../../assets/images/date-icon.svg";
import Pagination from "../../../../component/pagination/Pagination";
import JobMapList from "../JobMapList";
import FilterPageTwo from "../FilterPageTow";
import JobView from "../jobView/JobView";
import { customFooterIds } from "../../../../config/clients/clients";
import CareersCustomFooter from "../../CareersFooter/CareersCustomFooterBase";
import MicroJobNotFound from "../jobapplication/MicroJobNotFound";
import { useNavigate } from "react-router-dom";
import OptionThreeJobViewPage from "../OptionThree/OptionThreeJobViewPage";
import NoJobMatch from "../OptionThree/NoJobMatch";
import SimilarJobs from "../OptionThree/SimilarJobs";
import locationIcon from "../../../../assets/images/locationicon.svg";
import { useSelector } from "react-redux";
import "../../../../i18n/i18n";
import { useTranslation } from "react-i18next";
import applyNowIcon from "../../../../assets/images/apply-now-icon.svg";
import infoIcon from "../../../../assets/images/info-icon.svg";
import useClientConfig from "../../../../config/careers/clientConfig";
import tickWhiteRoundIcon from "../../../../assets/images/tick-white-round-icon.svg";
import OptionFourNoJob from "./OptionFourNoJob";
import WhyWorkWith from "../../header/clientsMenu/gre/WhyWorkWith";

const OptionFourJobListing = (props: any) => {
  const {
    location,
    clientId,
    checkListControl,
    jobsList,
    searchMobileFiler,
    filterViews,
    setListView,
    listView,
    setTableControl,
    tableControl,
    sortList,
    pageSizeChange,
    displayPage,
    filterView,
    moveToJobViewPage,
    publishingDate,
    pageChange,
    clientIds,
    filterListData,
    searchControlSubmit,
    navigateToJob,
    isMicroSite,
    isMapViewEnabled,
    getListOfJob,
  } = props;

  const clientConfig = useSelector((state: any) => state.careers.cliendConfig);
  const langLabels = clientConfig?.data?.data?.clientSettings?.languageSettings;
  const language = clientConfig?.data?.data?.clientSettings?.language;
  const showJobApplyButton =
    clientConfig?.data?.data?.clientSettings?.showJobApplyButtonInListing;
  const jobListingLangLabels = langLabels?.jobListing?.[0];
  const { clientSiteSettings } = useClientConfig();
  const templateName = clientSiteSettings?.templateName;
  const learnMoreBtn = clientSiteSettings?.learnMoreBtnInList || false;
  const applyNowBtn = clientSiteSettings?.applyNowBtnInList || false;

  const { t } = useTranslation();

  //Resolves if the current client has a custom footer using the inbuilt clientids
  const hasCustomFooter = (id: any) => {
    return clientSiteSettings?.showFooter;
  };
  const navigate = useNavigate();
  const navigateToJobAlerts = () => {
    navigate("/job-alerts");
  };

  const selectedSortList = {
    value: tableControl?.sort?.value,
    label: t(tableControl?.sort?.label),
  };

  const selectedPageSize = {
    value: tableControl?.pageSize?.value,
    label: tableControl?.pageSize?.value + " " + t(" per page"),
  };

  const langSortList = sortList.map((ress: any) => {
    return {
      value: ress.value,
      label: t(ress.label),
    };
  });

  const langPageSize = displayPage.map((resss: { value: string }) => {
    return {
      value: resss.value,
      label: resss.value + " " + t(" per page"),
    };
  });

  const navicateToApplayJob = (jobId: string) => {
    navigate(`/view/${jobId}/apply-job/from/direct`);
  };

  return (
    <div>
      {(location.pathname === "/" || location.pathname === "/jobs") ? (
        <div className="option4-job-list-parent" id={templateName === "gre" ? "option4-job-list-parent" : ""}>
          <div className="job-list option3-job-list pb-3">
            <div className="page-content-inner">
              <div className="page-content">
                <div className="page-content-left">
                  <div
                    className={`job-filter-box ${isMicroSite === 1 ? "d-none" : ""
                      }`}
                  >
                    <ul className="job-filter-box-list">
                      <li className="li-1">
                        <p>
                          {checkListControl ? (
                            <>{t("Search Results")}</>
                          ) : (
                            <>{jobListingLangLabels?.showingAll}</>
                          )}
                          <span className="primary-color ms-2">
                            {jobsList?.data?.data?.jobs?.totalRecord}
                          </span>
                        </p>

                        <div className="d-sm-flex d-lg-none d-md-flex  d-flex justify-content-end ms-auto cust-mob-job-filter-icon">
                          <Image
                            onClick={() => searchMobileFiler("listAndMapView")}
                            src={MobilSearchNew}
                          />
                          {/* <Image onClick={() => searchMobileFiler("filterView")} clasName={"ms-4"} src={MobilSearch} /> */}
                        </div>
                      </li>

                      {filterViews.listAndMapView ? (
                        <>
                          <li className="ml-auto">
                            <div
                              className="custom-btn-small-parent"
                              style={{
                                display: isMapViewEnabled === 0 ? "none" : "",
                              }}
                            >
                              <button
                                onClick={() => setListView("list")}
                                className={`btn custom-btn-smal  btn-sm ${listView === "list" ? "active" : ""
                                  } `}
                              >
                                {jobListingLangLabels?.listView}
                              </button>
                              <button
                                onClick={() => setListView("map")}
                                className={`btn custom-btn-smal  btn-sm ${listView === "map" ? "active" : ""
                                  } `}
                              >
                                {jobListingLangLabels?.mapView}
                              </button>
                            </div>
                          </li>

                          <li className=" mob-menu-hide mob-sort-filter cust-sort-drop">
                            <div className="d-flex top-filter position-relative">
                              <div className="custom-single-filter-parent">
                                <label>{jobListingLangLabels?.sortBy}:</label>
                                <SingleSelect
                                  className="sort-control"
                                  placeholder=""
                                  onChange={(e: any) => {
                                    setTableControl((prs: any) => {
                                      return {
                                        ...prs,
                                        sort: e,
                                      };
                                    });
                                  }}
                                  value={selectedSortList}
                                  options={langSortList}
                                  isSearchable={false}
                                />
                              </div>
                            </div>
                          </li>
                          <li className="mob-menu-hide mob-sort-filter cust-display-drop">
                            <div className="position-relative">
                              <div className="d-flex top-filter pl-0">
                                <div className="custom-single-filter-parent">
                                  <label>
                                    {jobListingLangLabels?.display}:
                                  </label>

                                  <SingleSelect
                                    className="sort-control"
                                    placeholder=""
                                    onChange={(e: any) => {
                                      pageSizeChange(e);
                                    }}
                                    value={selectedPageSize}
                                    options={langPageSize}
                                    isSearchable={false}
                                  />

                                  {/* <div className="drop-down-arrow"></div> */}
                                  {/* <i className="pi pi-angle-down element-control sort-icon"></i> */}
                                </div>
                              </div>
                            </div>
                          </li>
                        </>
                      ) : (
                        ""
                      )}
                    </ul>
                  </div>
                  {filterViews.filterView ? (
                    <div className="col-xxl-0 col-lg-0 col-md-12 col-sm-12 col-12 mob-job-search-parent d-none">
                      {filterView()}
                      {/* <JobFilter filter={filterListData} tableControl={tableControl} setTableControl={setTableControl} removeSearchForm={removeSearchForm} searchControlSubmit={searchControlSubmit} /> */}
                    </div>
                  ) : (
                    ""
                  )}
                  {tableControl.data.length > 0 ? (
                    <>
                      {listView === "list" ? (
                        <>
                          {tableControl.data.map((ress: any, i: number) => {
                            return (
                              <div
                                key={ress.id}
                                className="job-list-parent option4_listing"
                              >
                                <div className="job-list-heading">
                                  <div className="job-list-heading-left">
                                    <h2
                                      role="button"
                                      onClick={() => moveToJobViewPage(ress)}
                                    >
                                      {ress.title}
                                    </h2>
                                    <div className="job-details-parent">
                                      <div className="opt3-job-list-div">
                                        {ress.location?.location !== "" ? (
                                          <>
                                            <div className="common-before-icon cust-location pl-0">
                                              <Image src={locationIcon} />
                                              <span className="mob-hide-content ms-1 d-sm-none d-none d-md-block">
                                                {jobListingLangLabels?.location}
                                                :
                                              </span>
                                              <span className="post-on ms-md-1 ms-sm-1 ms-1">
                                                {ress.location?.location}
                                              </span>
                                            </div>
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        {clientSiteSettings.showPostedDate !== false && ress.postedAt !== "" ? (
                                          <>
                                            <div className="common-before-icon post-to pl-0">
                                              <Image src={DataIcon} />
                                              <span className="mob-hide-content ms-1 d-sm-none d-none d-md-block">
                                                {jobListingLangLabels?.posted}:
                                              </span>
                                              <span className="post-on ms-md-1 ms-sm-1 ms-1">
                                                {publishingDate(
                                                  ress.postedAt,
                                                  language
                                                )}
                                              </span>
                                            </div>
                                          </>
                                        ) : (
                                          ""
                                        )}

                                        {showJobApplyButton === 1 ? (
                                          <div className="btn-apply-new">
                                            <button
                                              onClick={() =>
                                                navicateToApplayJob(ress.id)
                                              }
                                            >
                                              <Image src={applyNowIcon} />
                                              {t("APPLY NOW")}
                                            </button>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="job-list-heading-right">
                                    <div className="job-list-img text-center">
                                      <img
                                        src={
                                          ress.logo
                                            ? ress.logo
                                            : "https://stag-compliance-careers.s3.ap-southeast-2.amazonaws.com/career-doc-settings/uploads/no_image.png"
                                        }
                                        className="img-fluid"
                                        alt="logo"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={
                                    (learnMoreBtn || applyNowBtn)
                                      ? "job-list-content job-list-content-btn-sec"
                                      : "job-list-content"
                                  }
                                >
                                  <div
                                    className="overflow-para job-view-description"
                                    dangerouslySetInnerHTML={{
                                      __html: ress.description,
                                    }}
                                  ></div>
                                  {(learnMoreBtn || applyNowBtn) ? (
                                    <div className="listing-btn-section">
                                      {learnMoreBtn ? (
                                        <button
                                          className="btn-new btn-primary-new listing-btn-learn"
                                          onClick={() => moveToJobViewPage(ress)}
                                        >
                                          {t("Learn More")}
                                        </button>
                                      ) : ""
                                      }
                                      {applyNowBtn ? (
                                        <button
                                          className="btn-new btn-secondary-new btn-new-opt4 listing-btn-apply"
                                          onClick={() =>
                                            navicateToApplayJob(ress.id)
                                          }
                                        >
                                          <Image src={tickWhiteRoundIcon} />
                                          {t("Apply Now")}
                                        </button>
                                      ) : ""
                                      }
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            );
                          })}
                          <div className="d-flex justify-content-center mt-3">
                            <Pagination
                              className="pagination-bar"
                              currentPage={tableControl.currentPage}
                              totalCount={tableControl.totalCount}
                              pageSize={tableControl.pageSize?.value}
                              onPageChange={(page: any) => pageChange(page)}
                            />
                          </div>
                        </>
                      ) : (
                        <JobMapList jobList={tableControl.data} />
                      )}
                    </>
                  ) : (
                    <>
                      {isMicroSite === 1 ? (
                        <MicroJobNotFound />
                      ) : (
                        <div>
                          <div className="job-list-parent">
                            <div className="text-center no-found-data">
                              {tableControl.massage}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          {
            clientSiteSettings?.templateName === "gre" ? (
              <>
                <OptionFourNoJob clientId={clientId} cliendConfig={clientConfig} navigateToJobAlerts={navigateToJobAlerts} navigateToJob={navigateToJob} />
              </>
            ) : ""
          }
          {
            clientSiteSettings?.templateName === "gre" ? (
              <WhyWorkWith />
            ) : ""
          }
          {/* {hasCustomFooter(clientId) ? (
            <>
              <CareersCustomFooter clientSiteSettings={clientSiteSettings} />
            </>
          ) : (
            ""
          )} */}
        </div>
      ) : (
        <>
          <OptionThreeJobViewPage
            jobDataView={filterView()}
            filterListData={filterListData}
            tableControl={tableControl}
            setTableControl={setTableControl}
            searchControlSubmit={searchControlSubmit}
            clientId={clientId}
            navigateToJob={navigateToJob}
            getListOfJob={getListOfJob}
          />
        </>
      )}
    </div>
  );
};

export default OptionFourJobListing;